import React from 'react';
import { ImageCarousel } from '@naf-simba/sections-image-carousel';
import { ArticleBlockContentGridCol } from './ArticleBlockContentGridCol';
import ResponsiveImage from '../../../../image/ResponsiveImage';
import utils from '../../../../../utils';
import { useMediaQuery } from '../../../../../hooks/useMediaQuery';
import { CloudinaryImageType } from '../../../../../../../types/CloudinaryImageType';
import { BlockContentContext } from '../../../BlockContent.utils';

interface ImageCarouselSerializerProps {
  value: { images: CloudinaryImageType[] };
}

const ImageCarouselImage = ({ image: { publicId, caption, altText } }: { image: CloudinaryImageType }) => (
  <ResponsiveImage imageId={publicId} altText={altText || caption} />
);

const ImageCarouselBlock = ({ value: { images } }: ImageCarouselSerializerProps) => {
  const isMobile = useMediaQuery('(max-width: 576px)');
  return (
    <ImageCarousel
      width={isMobile ? '350px' : '650px'}
      images={images.map((image) => ({
        render: () => <ImageCarouselImage image={image} />,
        description: `${image?.caption ? `${image?.caption}\n` : ''}${utils.getPhotographerAndCopyrightCaption({
          copyright: image?.copyright,
          photographer: image?.photographer,
        })}`,
      }))}
    />
  );
};

export const ImageCarouselSerializer = (context: BlockContentContext = BlockContentContext.Stripped) => {
  if (context === BlockContentContext.Article) {
    return ({ value }: ImageCarouselSerializerProps) => (
      <ArticleBlockContentGridCol>
        <ImageCarouselBlock value={value} />
      </ArticleBlockContentGridCol>
    );
  }
  return ({ value }: ImageCarouselSerializerProps) => <ImageCarouselBlock value={value} />;
};
